<template>
  <div class="login-container" style="background-image: url(back.jpg);background-position: bottom;">
    <div class="loginLogo">
        <img class="logiImg" :src="$baseUrl+ 'sekulogo4.png'">
    </div>
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" autocomplete="on"
             label-position="left">

      <div class="title-container">
        <h3 class="title">欢迎登录</h3>
      </div>

      <el-alert v-show="errorMsg" :title="errorMsg" type="error" show-icon style="margin-bottom: 10px"
                @close="errorMsg=null">
      </el-alert>

      <el-form-item prop="account" style="background-color: #F7F7F7;border: 1px solid #EBEBEB;">
        <svg-icon name="user" class="svg-container"/>
        <el-input
          ref="account"
          v-model="loginForm.account"
          placeholder="用户名"
          name="account"
          type="text"
          tabindex="1"
          autocomplete="on"
        />
      </el-form-item>

      <el-tooltip v-model="capsTooltip" content="Caps lock is On" placement="right" manual>
        <el-form-item prop="password" style="background-color: #F7F7F7;border: 1px solid #EBEBEB;">
          <svg-icon name="password" class="svg-container"/>
          <el-input
            :key="passwordType"
            ref="password"
            v-model="loginForm.password"
            :type="passwordType"
            placeholder="密码"
            name="password"
            tabindex="2"
            @keyup.native="checkCapsLock"
            @blur="capsTooltip = false"
            @keyup.enter.native="login"
          />
          <svg-icon :name="passwordType === 'password' ? 'eye' : 'eye-open'" class="show-pwd" @click="showPwd"/>
        </el-form-item>
      </el-tooltip>

      <el-button :loading="loading" type="primary" style="width:100%; height: 36px;margin-top:20px;"
                 @click.native.prevent="login">登录
      </el-button>
    </el-form>
    <div style="width: 100%;position: absolute;bottom: 0;text-align: center;">
        <div style="width:300px;margin:0 auto; padding:20px 0;">
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51010702002816" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
                <img :src="$baseUrl+'beian.png'" style="float:left;"/>
                <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">川公网安备 51010702002816号</p ></a>
                <a target="_blank" href="http://beian.miit.gov.cn/" style="color:gray"><p>蜀ICP备2022006976号-2</p></a>
        </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'Login',
    data () {
      return {
        loginForm: {
          account: null,
          password: null
        },
        loginRules: {
          account: [{
            required: true,
            trigger: 'blur',
            message: '请输入用户名'
          }],
          password: [{
            required: true,
            trigger: 'blur',
            message: '请输入密码'
          }]
        },
        passwordType: 'password',
        capsTooltip: false,
        loading: false,
        redirect: undefined,
        otherQuery: {},
        errorMsg: null
      }
    },
    mounted () {
      this.$refs.account.focus()
    },
    methods: {
      checkCapsLock (e) {
        const { key } = e
        this.capsTooltip = key && key.length === 1 && (key >= 'A' && key <= 'Z')
      },
      showPwd () {
        this.passwordType = this.passwordType === 'password' ? '' : 'password'
        this.$nextTick(() => {
          this.$refs.password.focus()
        })
      },
      login () {
        this.errorMsg = null
        this.$refs.loginForm.validate(valid => {
          if (!valid) return false

          this.loading = true
          this.$store.dispatch('user/login', this.loginForm).then(() => {
            this.$router.push({
              path: this.redirect || '/',
              query: this.otherQuery
            })
          }).catch(error => {
            this.errorMsg = error.msg
          }).finally(() => {
            this.loading = false
          })
        })
      },
      setTestAccount ({ account, password }) {
        this.loginForm.account = account
        this.loginForm.password = password
      },
      getOtherQuery (query) {
        return Object.keys(query).reduce((acc, cur) => {
          if (cur !== 'redirect') {
            acc[cur] = query[cur]
          }
          return acc
        }, {})
      }
    },
    watch: {
      $route: {
        handler: function (route) {
          const query = route.query
          if (query) {
            this.redirect = query.redirect
            this.otherQuery = this.getOtherQuery(query)
          }
        },
        immediate: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .login-container {
    /deep/
    .el-input {
      height: 47px;
      flex-grow: 1;
      margin-right: 10px;

      input {
        background: #F7F7F7;
        border: 0;
        border-radius: 0;
        color: #ADADAD;
        height: 47px;
        caret-color: #ADADAD;

        &:-webkit-autofill {
          box-shadow: 0 0 0px 1000px #F7F7F7 inset !important;
          -webkit-text-fill-color: #ADADAD !important;
        }
      }
    }

    .el-form-item {
      border: 1px solid rgba(255, 255, 255, 0.1);
      background: rgba(0, 0, 0, 0.1);
      border-radius: 5px;
      color: #454545;
      margin-bottom: 20px !important;
    }

    /deep/
    .el-form-item__content {
      display: flex;
      align-items: center;
    }
  }
</style>

<style lang="scss" scoped>
  $dark_gray: #889aa4;

  .login-container {
    height: 100%;
    min-width: 300px;
    background-color: #2d3a4b;
    overflow: auto;

    .title-container {
      .title {
        font-size: 26px;
        color: #090909;
        margin: 0px auto 40px auto;
        text-align: center;
        font-weight: bold;
      }
    }

    .login-form {
      background-color: #FFFFFF;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -190px;
      margin-left: -225px;
      box-sizing: border-box;
      width: 500px;
      max-width: 100%; // 当父容器空间不足，width 会缩小适应
      padding: 50px 30px 60px 30px;
    }

    .svg-container {
      box-sizing: border-box;
      width: 30px;
      padding-left: 15px;
      color: $dark_gray;
    }

    .show-pwd {
      margin-right: 10px;
      font-size: 16px;
      color: $dark_gray;
      cursor: pointer;
    }
    .loginLogo{
        width: 110px;
        height: 50px;
        margin: 20px 20px;
    }

    .logiImg{
        width:100%;
        height: 100%;
    }
  }
</style>
